import { useModalStore } from '@wemogy/reactbase';
export default function useSearchAndReplace(dataAccessStore, customPatchHandler) {
    var modalStore = useModalStore();
    return {
        openSearchAndReplaceModal: function (propertyName, humanizeSearchResultIdentifier, replaceCallback) {
            modalStore.openModal('searchAndReplace', {
                dataAccessStore: dataAccessStore,
                propertyName: propertyName,
                humanizeSearchResultIdentifier: humanizeSearchResultIdentifier,
                replaceCallback: replaceCallback,
                customPatchHandler: customPatchHandler
            });
        }
    };
}
//# sourceMappingURL=UseSearchAndReplace.js.map